<template>
  <BaseFrame
    submitText="提交"
    @submit='submit'
    clearText=""
    @cancel='$router.push(-1)'
  >
    <div slot="content">
    <lk-card v-if="this.$route.params.id != 4">
      <lk-form
        :label-width='130'
        label-position="right"
        :model='ruleFormData'
        :rules="formValidate"
        ref="ruleForm">
        <lk-row :gutter='16'>
          <lk-col>
            <lk-form-item label='规则名称:'>
              <span>{{ruleName}}</span>
            </lk-form-item>
          </lk-col>
        </lk-row>
        <template v-if='dateLimitationsRule'>
          <lk-row :gutter='16'>
            <lk-col span='10'>
              <lk-form-item label='设定时间:' prop='time'>
                <timeStampDatePicker
                  :disabled='config.disabled'
                  :confirm='true'
                  type="datetimerange"
                  :options='options'
                  format="yyyy-MM-dd HH:mm"
                  :timePickerOptions='timePickerOptions'
                  v-model="ruleFormData.time"
                ></timeStampDatePicker>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row :gutter='16'>
            <lk-col>
              <lk-form-item label='受限报表类型:' prop="">
                <span>库存查询、出入库明细、库存汇总表、销售明细查询、零售明细、器械销售明细查询、饮片销售明细查询、处方药销售记录查询、含麻黄碱复方制剂销售记录查询</span>
              </lk-form-item>
            </lk-col>
          </lk-row>
        </template>
        <div v-if="systemLimitationsRule">
          <lk-row :gutter='16'>
            <lk-col span='10'>
              <lk-form-item label='盘点类型选项:' prop='type'>
                <lk-select v-model="ruleFormData.type" filterable :multiple="true" :disabled='config.disabled'>
                  <lk-option v-for="(item,i) in typeOptions" :key="i" :value='item.id'>{{item.name}}</lk-option>
                </lk-select>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row :gutter='16'>
            <lk-col span='10'>
              <lk-form-item label='盘点方式选项:' prop='pattern'>
                <lk-select v-model="ruleFormData.pattern" filterable :multiple="true" :disabled='config.disabled'>
                  <lk-option v-for="(item,i) in patternOptions" :key="i" :value='item.id'>{{item.name}}</lk-option>
                </lk-select>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row :gutter='16'>
            <lk-col span='10'>
              <lk-form-item label='生效时间段:' prop='time'>
                <timeStampDatePicker
                  :disabled='config.disabled'
                  :confirm='true'
                  type="datetimerange"
                  :options='options'
                  format="yyyy-MM-dd HH:mm"
                  :timePickerOptions='timePickerOptions'
                  v-model="ruleFormData.time"
                ></timeStampDatePicker>
              </lk-form-item>
            </lk-col>
          </lk-row>
        </div>
        <lk-row :gutter='16'>
          <lk-col span='20'>
            <lk-form-item label='门店白名单:'>
              <lk-table :columns='columns' :data='tableData' border ></lk-table>
            </lk-form-item>
          </lk-col>
        </lk-row>
      </lk-form>
    </lk-card >
    <lk-form
        :model="planForm"
        label-position="right"
        :label-width="140"
        :rules="planRules"
        ref="planForm"
        v-else
        >
        <!-- 总部周盘 -->
        <lk-card title="详细信息" class="mb16">
            <lk-row :gutter="16">
                <lk-col>
                  <lk-form-item label="规则名称:" prop="ruleName">
                    <lk-input class="width180" v-model.trim="planForm.ruleName" :maxlength="50" :disabled="config.disabled"></lk-input>
                  </lk-form-item>
                </lk-col>
                <lk-col span="10">
                    <lk-form-item label="盘点商品:" prop="goodsSalePrice">
                        <lk-checkbox-group v-model="checkboxList">
                            <lk-checkbox label="goodsSalePrice" disabled >
                            商品售价 ≥ </lk-checkbox>
                            <lk-input class="width60" v-model.trim="planForm.goodsSalePrice" :value="planForm.goodsSalePrice" :maxlength="50" :disabled="config.disabled"></lk-input> 元
                        </lk-checkbox-group>
                    </lk-form-item>
                    <lk-form-item prop="goodsExpiryDays">
                        <lk-checkbox-group v-model="checkboxList">
                            <lk-checkbox label="goodsExpiryDays" :disabled="config.disabled">
                        商品近效期 ≤ <lk-input class="width60" v-model.trim="planForm.goodsExpiryDays" :maxlength="50" :disabled="config.disabled"></lk-input> 天
                            </lk-checkbox>
                        </lk-checkbox-group>
                    </lk-form-item>
                    <lk-form-item prop="goodsNoSaleRecDays">
                        <lk-checkbox-group v-model="checkboxList">
                            <lk-checkbox label="goodsNoSaleRecDays" :disabled="config.disabled">
                        商品在近 <lk-input class="width60" v-model.trim="planForm.goodsNoSaleRecDays" :maxlength="50" :disabled="config.disabled"></lk-input> 天内没有销售记录
                            </lk-checkbox>
                        </lk-checkbox-group>
                    </lk-form-item>
                    <lk-form-item prop="goodsSaleRecDays">
                        <lk-checkbox-group v-model="checkboxList">
                            <lk-checkbox label="goodsSaleRecDays" :disabled="config.disabled">
                        商品在近 <lk-input class="width60" v-model.trim="planForm.goodsSaleRecDays" :maxlength="50" :disabled="config.disabled"></lk-input> 天内有销售记录
                        </lk-checkbox>
                        </lk-checkbox-group>
                    </lk-form-item>
                </lk-col>
            </lk-row>
            <lk-row :gutter="16">
                <lk-col>
                    <div class="left100">以上选项选择后会将各个门店符合对应条件的商品加入周盘盘点表中。（满足任意条件就会加入）</div>
                    <div class="left100 bottom16">如果某个门店库存总数大于0商品少于10个，则该门店盘点表无视条件默认全盘。</div>
                </lk-col>
            </lk-row>
        </lk-card>
    </lk-form>
  </div>
</BaseFrame>
</template>
<script>
import utils from '@/libs/utils';
import tools from '@/services/tools';
import BaseFrame from '@/components/frame/BaseFrame.vue';
import system from '@/services/system';

export default {
  name: 'stocktakingRuleDetail',
  components: {
    BaseFrame,
  },
  watch: {
  },
  computed: {
    selectedStoreIds() {
      return this.tableData.map(item => item.storeId);
    },
    // 是否是系统限制规则 --(几个select是否显示)
    systemLimitationsRule() {
      return this.config.whiteType === 1;
    },
    // 是否是按日期限制查询、导出报表
    dateLimitationsRule() {
      return this.config.whiteType === 3;
    },
    needFormValidate() {
      return this.config.whiteType === 1 || this.config.whiteType === 3;
    },
  },
  data() {
    return {
      ruleName: '',
      config: {
        disabled: false, // 页面能否编辑(查看页不能编辑)
        whiteType: 1,
      },
      routeName: 'stocktakingRuleEdit',
      options: {
        disabledDate(date) {
          return date && date.valueOf() < Date.now() - 86400000;
        },
      },
      timePickerOptions: { steps: [1, 15] },
      ruleFormData: {},
      formValidate: {
        type: [
          {
            required: true,
            message: '请选择盘点类型',
            trigger: 'change',
            type: 'array',
          },
        ],
        pattern: [
          {
            required: true,
            message: '请选择盘点方式',
            trigger: 'change',
            type: 'array',
          },
        ],
        time: [
          {
            required: true,
            message: '请选择生效时间段',
            trigger: 'change',
            type: 'array',
          },
        ],
      },
      patternOptions: [
        {
          id: 1,
          name: '明盘',
        },
        {
          id: 2,
          name: '暗盘',
        },
      ],
      typeOptions: [
        {
          id: 2,
          name: '总部周盘',
        },
        {
          id: 1,
          name: '总部月盘',
        },
        {
          id: 3,
          name: '门店常规盘点',
        },
        {
          id: 4,
          name: '其他',
        },
      ],
      storeList: [],
      tableData: [],
      columns: [
        {
          title: '序号',
          type: 'index',
          minWidth: 80,
        },
        {
          title: '门店',
          key: 'storeId',
          minWidth: 116,
          render: (h, params) => {
            const optionArr = [];
            this.storeList.forEach((storeItem) => {
              const obj = h('lk-option',
                {
                  props: {
                    value: storeItem.id,
                    disabled: this.selectedStoreIds.includes(storeItem.id),
                  },
                }, storeItem.name);
              optionArr.push(
                obj,
              );
            });
            return h('lk-select',
              {
                on: {
                  'on-change': (value) => {
                    this.tableData[params.index].storeId = value;
                  },
                  'on-clear': () => {
                    if (this.tableData.length === 1) {
                      this.tableData = [{}];
                    } else {
                      this.tableData.splice(params.index, 1);
                    }
                  },
                },
                props: {
                  value: params.row.storeId,
                  clearable: true,
                  transfer: true,
                  filterable: true,
                  disabled: this.config.disabled,
                },
              },
              optionArr);
          },
        },
        {
          title: '操作',
          minWidth: 26,
          render: (h, params) => h('div', [
            h('lk-button', {
              props: {
                size: 'small',
                type: 'text',
                disabled: this.tableData.length === 1 || this.config.disabled,
              },
              on: {
                click: () => {
                  this.tableData.splice(params.index, 1);
                },
              },
            }, '删除'),
            params.index === this.tableData.length - 1 ? h('lk-button', {
              props: {
                size: 'small',
                type: 'text',
                disabled: this.config.disabled,
              },
              on: {
                click: () => {
                  const emptyArr = this.tableData.filter(item => JSON.stringify(item) === '{}');
                  if (emptyArr.length) {
                    this.$Message.warning('请选择门店');
                    return;
                  }
                  const tableLength = this.tableData.length;
                  const storelistLength = this.storeList.length;
                  if (tableLength === storelistLength) {
                    this.$Message.warning(`最多添加${storelistLength}条门店白名单`);
                    return;
                  }
                  this.tableData.push({});
                },
              },
            }, '新增') : null,
          ]),
        },
      ],
      defaultList: ['goodsSalePrice', 'goodsExpiryDays', 'goodsNoSaleRecDays', 'goodsSaleRecDays'],
      checkboxList: ['goodsSalePrice'],
      planForm: {
        goodsSalePrice: '800',
        goodsExpiryDays: '180',
        goodsNoSaleRecDays: '180',
        goodsSaleRecDays: '7',
        goodsCondition: '',
        ruleName: '',
        id: 4,
      },
      planRules: {
        ruleName: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur',
          },
        ],
        goodsSalePrice: [
          {
            required: true,
            message: '请填写商品售价',
            trigger: 'blur',
          }, {
            validator: utils.validate.numberValidator,
            trigger: 'blur',
          },
        ],
        goodsExpiryDays: [
          {
            message: '请输入数字',
            trigger: 'blur',
          }, {
            validator: utils.validate.numberValidator,
            trigger: 'blur',
          },
        ],
        goodsNoSaleRecDays: [
          {
            message: '请输入数字',
            trigger: 'blur',
          }, {
            validator: utils.validate.numberValidator,
            trigger: 'blur',
          },
        ],
        goodsSaleRecDays: [
          {
            message: '请输入数字',
            trigger: 'blur',
          }, {
            validator: utils.validate.numberValidator,
            trigger: 'blur',
          },
        ],
      },
    };
  },
  methods: {
    submit() {
      if (this.$route.params.id == 4) { // 抽盘单独写
        this.checkSubmit();
        return;
      }
      const storeList = this.tableData;
      // 如果是系统规则
      let params = {
        storeList,
        id: this.$route.params.id,
      };
      if (this.needFormValidate) {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            const { type, pattern } = this.ruleFormData;
            const startTime = this.ruleFormData.time[0];
            const endTime = this.ruleFormData.time[1];
            params = {
              type,
              pattern,
              startTime,
              endTime,
              storeList,
              id: this.$route.params.id,
            };
            if (this.dateLimitationsRule) {
              params = {
                startTime,
                endTime,
                storeList,
                id: this.$route.params.id,
              };
            }
            this.toUpdate(params);
          }
        });
      } else {
        this.toUpdate(params);
      }
    },
    checkSubmit() { // 抽盘单独处理
      const tempCondition = {};
      let tempHaveDot = false;
      this.checkboxList.forEach((key) => {
        tempCondition[key] = this.planForm[key];
        if (!tempHaveDot && typeof (this.planForm[key]) == 'string') {
          tempHaveDot = this.planForm[key].includes('.');
        }
      });
      if (tempHaveDot) {
        this.$Message.error('多少天中不能包含 小数点');
        return;
      }
      this.$delete(tempCondition, 'id');
      this.$delete(tempCondition, 'ruleName');
      this.planForm.goodsCondition = JSON.stringify(tempCondition);
      this.clearDefaultData();
      this.toUpdate(this.planForm);
    },
    toUpdate(param) {
      tools.updateRule(param).then((res) => {
        if (res.data.status === 200) {
          this.$router.push({name: 'stocktakingRuleConfig'});
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getDate() {
      const params = {
        id: this.$route.params.id,
      };
      tools.getRuleDetail(params).then((res) => {
        if (res.data.status === 200) {
          const {
            types,
            patterns,
            startTime,
            endTime,
            storeList,
            whiteType,
            ruleName,
            goodsConditionModel,
          } = res.data.data;
          this.ruleName = ruleName;
          this.config.whiteType = whiteType;
          if (this.$route.name === 'stocktakingRuleCheck') {
            this.tableData = storeList;
          } else {
            if (storeList) {
              this.tableData = storeList;
            } else {
              this.tableData = [{}];
            }
          }
          const time = [startTime, endTime];
          this.ruleFormData = {
            type: types,
            pattern: patterns,
            time,
          };
          if (this.$route.params.id == 4) {
            this.planForm = goodsConditionModel;
            this.planForm.ruleName = res.data.data.ruleName;
            this.planForm.id = res.data.data.id;
            this.checkboxList = Object.keys(goodsConditionModel);
          }
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getStores() {
      return new Promise((resolve) => {
        system.getBelongStores().then((res) => {
          this.storeList = [];
          if (res.data.status === 200) {
            this.storeList = res.data.data;
            resolve();
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    clearDefaultData() {
      this.defaultList.forEach((key) => {
        this.$delete(this.planForm, key);
      });
    },
  },
  mounted() {
    const { name } = this.$route;
    this.config.disabled = !(name === this.routeName);
    this.getStores().then(() => {
      this.getDate();
    });
  },
};
</script>
<style lang="less" scoped>
.width60 {
  width: 60px;
}
.width180 {
  width: 300px;
}
.left100 {
  margin-left: 139px !important;
}
.bottom16 {
  margin-bottom: 16px !important;
}
</style>
